import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const UnarchiveIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue169'}</MuiIcon>
    );
}
